import { VySelect, type VySelectProps } from '@vy/ui-design-system';
import { Controller, type FieldPath, type FieldValues } from 'react-hook-form';
import { useFieldController } from './useFieldController';

export type VySelectFieldProps<TForm extends FieldValues, TOption> = Omit<
  VySelectProps<TOption>,
  'value' | 'onChange' | 'onBlur' | 'error' | 'helperText' | 'ref'
> & {
  name: FieldPath<TForm>;
  helperText?: string;
};

export function VySelectField<TForm extends FieldValues, TOption>({
  name,
  helperText,
  ...rest
}: VySelectFieldProps<TForm, TOption>) {
  const { control, message } = useFieldController<TForm>(name);
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <VySelect<TOption>
          {...rest}
          value={field.value as TOption | null}
          onChange={(_event, next) => field.onChange(next)}
          onBlur={field.onBlur}
          error={Boolean(message)}
          helperText={message ?? helperText}
        />
      )}
    />
  );
}
